// Website configuration
export const siteConfig = {
  // Company information
  company: {
    name: "Nexus Living",
    logo: "/images/logos/nexus-logo.svg",
    description: "Nexus Living is more than a housing concept—it's an investment strategy. Designed for the growing demand of young professionals. Nexus Living combines modern design, prime locations, and essential amenities at accessible price points."
  },

  // Navigation configuration
  navigation: {
    logo: "/images/logos/nexus-logo.svg",
    logoDark: "/images/logos/nexus-logo-footer.svg",
    logoMobile: "/images/logos/nexus-logo-mobile.svg",
    menuItems: [
      { label: "Home", href: "#home", active: true },
      { label: "Why Nexus Living", href: "#why-nexus", active: false },
      { label: "Contact Us", href: "#contact", active: false }
    ],
    downloadButton: {
      text: "Get the Brochure",
      href: "#download"
    }
  },

  // Hero section configuration
  hero: {
    backgroundImage: "/images/hero/hero-background.jpg",
    title: "Where modern living meets smart investment.",
    altText: "Nexus Asili Hero"
  },

  // Why Nexus Living page hero section configuration
  whyNexusHero: {
    backgroundImage: "/images/hero/why-nexus-hero.jpg",
    title: "",
    altText: "Why Nexus Living Hero"
  },

  // Contact Us page hero section configuration
  contactHero: {
    backgroundImage: "/images/hero/contact-hero.jpg",
    title: "Contact Us",
    altText: "Contact Us Hero"
  },

  // Company introduction configuration
  companyIntro: {
    title: "Company Intro",
    image: "/images/company/company-intro.jpg",
    description: "Nexus Living is more than a housing concept—it's an investment strategy. Designed for the growing demand of young professionals. Nexus Living combines modern design, prime locations, and essential amenities at accessible price points.",
    buttonText: "About Us",
    buttonHref: "#about"
  },

  // Nexus Asili module configuration
  projects: {
    title: "Projects",
    projectName: "Nexus Asili",
    description: "Nexus Asili is the inaugural development by Nexus Living, designed to embody our vision of blending modern lifestyle with high-return investment opportunities.",
    sideImage: "/images/projects/nexus-asili-side.jpg"
  },

  // Map module configuration
  map: {
    mainImage: "/images/projects/nexus-asili-main.jpg",
    overlayText: "Asili, meaning \"origin,\" reflects both the beginning of our journey and our commitment to building on strong foundations. This project sets the benchmark for timely delivery, assured quality, and sustainable returns, showcasing the principles that will define every Nexus Living development to come.",
    locationButtonText: "Click Here to View Location",
    locationButtonHref: "#location",
  },

  // Standalone brochure button configuration
  brochure: {
    text: "Get the Brochure"
  },

  // About Us module configuration
  aboutUs: {
    title: "About Us",
    image: "/images/achievement/construction-workers.jpg",
    paragraphs: [
      "Nexus Living is a forward-looking real estate brand that turns modern lifestyle needs into high-return investment opportunities. We focus on creating housing concepts that balance affordability, design, and convenience, ensuring strong rental demand and long-term value appreciation.",
      "By aligning each development with shifting urban living trends, we deliver assets that perform—offering our investors reliable yields, capital growth, and a resilient foothold in the property market. At Nexus Living, we connect lifestyle and investment, building properties that people aspire to live in and investors trust to grow their wealth."
    ]
  },

  // What We Do module configuration
  whatWeDo: {
    title: "What We Do",
    services: [
      {
        label: "Design",
        icon: "/images/icons/design-icon.svg"
      },
      {
        label: "Sell",
        icon: "/images/icons/sell-icon.svg"
      },
      {
        label: "Build",
        icon: "/images/icons/build-icon.svg"
      },
      {
        label: "Manage",
        icon: "/images/icons/manage-icon.svg"
      }
    ]
  },

  // Achievement module configuration
  achievement: {
    backgroundText: "Achievements",
    title: "Description of previous projects",
    engineeringLeadership: {
      title: "Our Engineering Leadership",
      text: "Leading our project execution is a Chief Engineer with a two-decade track record, whose recent experience includes a key leadership role in the development of Egypt's New Administrative Capital in New Cairo. He ensures the global standards he commanded on a national scale are meticulously applied to every square meter of Nexus Asili."
    },
    constructionPartners: {
      title: "Our Specialist Construction Partners",
      text: "To construct Nexus Asili, we have engaged elite specialist firms whose expertise is proven on Africa's most demanding projects. Their portfolio is a showcase of African landmarks:",
      achievements: [
        "They were the hands-on execution force behind Kenya's largest venue, the 60,000-seat Talanta Sports Stadium.",
        "They also delivered critical phases of Africa's tallest skyscraper, the Iconic Tower in Egypt, a project built under one of the world's most demanding quality supervision standards."
      ]
    },
    images: {
      topRight: "/images/achievement/engineering-work.jpg",
      bottomRight: "/images/achievement/skyscrapers.jpg"
    }
  },

  // Contact Us page configuration
  contactForm: {
    title: "Contact Form"
  },

  contactInfo: {
    email: "info@nexusliving.ke",
    phone: "+254 717 959595",
    mapImage: "/images/contact/contact-map.jpg",
    locationName: "Kovii Center"
  },

  // Pricing configuration
  pricing: {
    title: "About Price",
    units: [
      {
        id: "one-bedroom",
        title: "1 bedroom",
        price: "2.7M",
        expectedRent: "27,500",
        plinthArea: "380 sqft",
        backgroundImage: "/images/backgrounds/pricing-bg-1.png",
        paymentPlans: [
          {
            months: 6,
            price: "3.0M",
            deposit: "600K",
            monthlyInstallments: "400K"
          },
          {
            months: 12,
            price: "3.3M",
            deposit: "660K",
            monthlyInstallments: "220K"
          }
        ]
      },
      {
        id: "studio",
        title: "studio",
        price: "1.8M",
        expectedRent: "18,000",
        plinthArea: "290 sqft",
        backgroundImage: "/images/backgrounds/pricing-bg-2.png",
        paymentPlans: [
          {
            months: 6,
            price: "2.0M",
            deposit: "400K",
            monthlyInstallments: "267K"
          },
          {
            months: 12,
            price: "2.2M",
            deposit: "440K",
            monthlyInstallments: "147K"
          }
        ]
      }
    ]
  },

  // Footer configuration
  footer: {
    links: [
      { label: "Terms of Service", href: "terms-of-service.html" },
      { label: "Privacy Policy", href: "privacy-policy.html" },
      { label: "About Us", href: "#why-nexus" }
    ],
    copyright: "Copyright © 2025 Nexus Living Limited. All Rights Reserved.",
    logo: "/images/logos/nexus-logo-footer.svg"
  },

  // Theme configuration
  theme: {
    colors: {
      primary: "#5277f1",
      primaryDark: "#3b5bdb",
      primaryDarker: "#2d4bc4",
      text: "#012059",
      textSecondary: "#6b7280",
      background: "#fff",
      backgroundSecondary: "#f8f9fa",
      border: "#e0e0e0"
    },
    fonts: {
      primary: "'Inter', sans-serif",
      weights: {
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        black: 900
      }
    }
  }
};
